import { Booking as BookingModel } from 'acscp/store';
import { defineMessages, FormattedMessage } from 'react-intl';
import { getTranslatedViewItineraryString } from 'acscp/components/common/helpers/sharedViewItineraryText';

const messages = defineMessages({
    expiredStatus: {
        id: 'components.bookings.booking.expiredStatus',
        defaultMessage: 'EXPIRED'
    },
    expiredWhatsThis: {
        id: 'components.bookings.booking.expiredWhatsThis',
        defaultMessage: 'This enquiry is no longer valid, as the first flight date has passed without being '
        +   'finalised. Please contact your account manager for more information.'
    },
    enquiryExpiredStatus: {
        id: 'components.bookings.booking.enquiryExpiredStatus',
        defaultMessage: 'EXPIRED'
    },
    enquiryExpiredWhatsThis: {
        id: 'components.bookings.booking.enquiryExpiredWhatsThis',
        defaultMessage: 'This enquiry is no longer valid, as the first flight date has passed without being ' +
            'finalised. Please contact your account manager for more information.'
    },
    quotesAvailableStatus: {
        id: 'components.bookings.booking.quotesAvailableStatus',
        defaultMessage: 'QUOTES AVAILABLE'
    },
    quotesAvailableWhatsThis: {
        id: 'components.bookings.booking.quotesAvailableWhatsThis',
        defaultMessage: 'Your account manager has prepared quotes for you to review. ' +
            'Please have a look and accept the quote you\'re happy with. ' +
            'If none quite fit your requirements - please contact your account manager.'
    },
    awaitingQuotesStatus: {
        id: 'components.bookings.booking.awaitingQuotesStatus',
        defaultMessage: 'AWAITING QUOTES'
    },
    awaitingQuotesWhatsThis: {
        id: 'components.bookings.booking.awaitingQuotesWhatsThis',
        defaultMessage: 'We\'ve received your enquiry, ' +
            'and the account manager is currently gathering quotes for you to choose from.'
    },
    flightPlanningStatus: {
        id: 'components.bookings.booking.flightPlanningStatus',
        defaultMessage: 'FLIGHT PLANNING'
    },
    flightPlanningWhatsThis: {
        id: 'components.bookings.booking.flightPlanningWhatsThis',
        defaultMessage: 'Your account manager is currently preparing the flight itinerary and details for you.'
    },
    submittedStatus: {
        id: 'components.bookings.booking.submittedStatus',
        defaultMessage: 'SUBMITTED TO ACCOUNT MANAGER'
    },
    submittedWhatsThis: {
        id: 'components.bookings.booking.submittedWhatsThis',
        defaultMessage: 'This new enquiry has been submitted to your account manager. '
        + 'Once suitable aircraft have been sourced, your quotes will be prepared and published to the JetPortal.'
    },
    checkingAvailabilityStatus: {
        id: 'components.bookings.booking.checkingAvailabilityStatus',
        defaultMessage: 'CHECKING AVAILABILITY'
    },
    checkingAvailabilityWhatsThis: {
        id: 'components.bookings.booking.checkingAvailabilityWhatsThis',
        defaultMessage: 'A quote for this booking has been selected. ' +
            'Your account manager is now securing that booking for you.'
    },
    itineraryAvailableStatus: {
        id: 'components.bookings.booking.confirmedStatus',
        defaultMessage: 'CONFIRMED'
    },
    itineraryAvailableWhatsThis: {
        id: 'components.bookings.booking.confirmedWhatsThis',
        defaultMessage: 'Your charter is booked! You can see the details by tapping on "{viewItineraryButtonText}".',
    },
    flownStatus: {
        id: 'components.bookings.booking.flownStatus',
        defaultMessage: 'FLOWN'
    },
    flownWhatsThis: {
        id: 'components.bookings.booking.flownWhatsThis',
        defaultMessage: 'This booking has now completed.'
    }
});

export function getStringsForBooking(
    translator: (msg: FormattedMessage.MessageDescriptor, values?: any) => string, booking: BookingModel):
    { status: string, whatsThis: string } {
    switch (booking.status) {
        case 'Expired':
            return {
                status: translator(messages.expiredStatus),
                whatsThis: translator(messages.expiredWhatsThis)
            };
        case 'Enquiry':
            return {
                status: translator(messages.submittedStatus),
                whatsThis: translator(messages.submittedWhatsThis)
            };
        case 'EnquiryExpired':
            return {
                status: translator(messages.enquiryExpiredStatus),
                whatsThis: translator(messages.enquiryExpiredWhatsThis)
            };
        case 'QuotesAvailable':
            return {
                status: translator(messages.quotesAvailableStatus),
                whatsThis: translator(messages.quotesAvailableWhatsThis)
            };
        case 'AwaitingQuotes':
            return {
                status: translator(messages.awaitingQuotesStatus),
                whatsThis: translator(messages.awaitingQuotesWhatsThis)
            };
        case 'FlightPlanning':
            return {
                status: translator(messages.flightPlanningStatus),
                whatsThis: translator(messages.flightPlanningWhatsThis)
            };
        case 'CheckingAvailability':
            return {
                status: translator(messages.checkingAvailabilityStatus),
                whatsThis: translator(messages.checkingAvailabilityWhatsThis)
            };
        case 'ItineraryAvailable':
            const translatedTextOnViewItineraryButton = getTranslatedViewItineraryString(translator);
            return {
                status: translator(messages.itineraryAvailableStatus),
                whatsThis: translator(
                    messages.itineraryAvailableWhatsThis,
                    { viewItineraryButtonText: translatedTextOnViewItineraryButton }
                )
            };
        case 'Flown':
            return {
                status: translator(messages.flownStatus),
                whatsThis: translator(messages.flownWhatsThis)
            };
    }
}
